import { useLocation } from 'react-router-dom';
import { useState } from 'react';
import i18n from '../i18n.js';
import { useTranslation } from 'react-i18next'

function Navbar() {
    let dynamicClass = '';
    let logoCol = '';
    const location = useLocation();
    const [scrolled, setScrolled] = useState(false);
    const [navOpen, setNavOpen] = useState(false);
    const path = location.pathname

    const { t } = useTranslation(); // Use the useTranslation hook

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    const changeBackground = () => {
        if (window.scrollY >= 100) {
            setScrolled(true);
        } else {
            setScrolled(false);
        }
    }

    const openNav = () => {
        setNavOpen(!navOpen)
    }

    if (scrolled || path !== '/') {
        dynamicClass = 'bg-primary';
        logoCol = 'text-white';
    } else {
        dynamicClass = 'bg-transparent';
        logoCol = 'text-secondary'
    }

    window.addEventListener('scroll', changeBackground)

    return (
        <nav className={`fixed w-full ${dynamicClass} top-0`}>
            <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
                <div className="relative flex h-16 items-center justify-between">
                    <div className="flex flex-1 items-center justify-start sm:items-stretch sm:justify-between">
                        <div className="flex shrink-0 items-center">
                            <div className={`text-2xl text-bold luckiest-guy ${logoCol}`}>JAA GEGEEN KANKO</div>
                        </div>
                        <div className="hidden sm:block">
                            <div className="flex space-x-4 items-center justify-center">
                                <a href="/" aria-current="page" className={`rounded-md px-3 py-2 text-sm font-medium text-white text-white ${path === '/' ? 'bg-secondary' : 'hover:bg-white hover:text-black'}`}>{t("navigation.home")}</a>
                                <a href="/tours" className={`rounded-md px-3 py-2 text-sm font-medium text-white text-white ${path === '/tours' ? 'bg-secondary' : 'hover:bg-white hover:text-black'}`}>{t("navigation.tours")}</a>
                                <a href="/about" className={`rounded-md px-3 py-2 text-sm font-medium text-white text-white ${path === '/about' ? 'bg-secondary' : 'hover:bg-white hover:text-black'}`}>{t("navigation.about_us")}</a>

                                {
                                    localStorage.getItem('i18nextLng') === 'en' ? <button className="text-white" onClick={() => changeLanguage('jp')}> <span class="fi fi-gb"></span></button> : <button className="text-white" onClick={() => changeLanguage('en')}><span class="fi fi-jp"></span></button>
                                }
                            </div>
                        </div>
                    </div>
                    {
                        localStorage.getItem('i18nextLng') === 'en' ? <button className="absolute inset-y-0 right-10 flex items-center sm:hidden text-white" onClick={() => changeLanguage('jp')}> <span class="fi fi-gb"></span></button> : <button className="absolute inset-y-0 right-10 flex items-center sm:hidden text-white" onClick={() => changeLanguage('en')}><span class="fi fi-jp"></span></button>
                    }
                    <div className="absolute inset-y-0 right-0 flex items-center sm:hidden">
                        <button type="button" command="--toggle" commandfor="mobile-menu" className="relative inline-flex items-right justify-right rounded-md p-2 text-white" onClick={openNav}>
                            <span className="absolute -inset-0.5"></span>
                            <span className="sr-only">Open main menu</span>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" data-slot="icon" aria-hidden="true" className="size-6 in-aria-expanded:hidden">
                                <path d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>

            <el-disclosure id="mobile-menu" hidden className="block sm:hidden">
                <div className={`space-y-1 px-2 pt-2 pb-3 bg-primary ${navOpen ? '' : 'hidden'}`}>
                    <a href="/" aria-current="page" className="block rounded-md bg-secondary px-3 py-2 text-base font-medium text-white">Home</a>
                    <a href="/tours" className="block rounded-md px-3 py-2 text-base font-medium text-white hover:bg-white hover:text-black">Tours</a>
                    <a href="/about" className="block rounded-md px-3 py-2 text-base font-medium text-white hover:bg-white hover:text-black">About Us</a>
                </div>
            </el-disclosure>
        </nav >
    );
}

export default Navbar;
